import React from 'react';

const CompanyList = ({ deal }) => {
  const getList = () => {
    if (Array.isArray(deal)) {
      return deal.map((item, index) => (
        <li
          className="deal-merchant-logo__item"
          key={`logo_business_${item.id} || ''}_${index}`}
        >
          {item}
        </li>
      ));
    }

    return <li className="deal-merchant-logo__item">{deal}</li>;
  };

  return (
    <>
      <ul className="deal-merchant-logo__list text-center">{getList()}</ul>
      <style global jsx>{`
        .deal-merchant-logo__list {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .deal-merchant-logo__item + .deal-merchant-logo__item {
          margin-top: 15px;
        }
      `}</style>
    </>
  );
};

export default CompanyList;
